(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEditLearningJournalTab", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemType/learningItemEditLearningJournalTabView.html",
            controller: ["learningItemFilesResource", "Upload", "$scope", "$timeout", "notify", "_", "$uibModal", LearningItemEditLearningJournalTabCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditLearningJournalTabCtrl(learningItemFilesResource, Upload, $scope, $timeout, notify, _, $uibModal) {
            var vm = this;
            vm.MaxAllowedFiles = 1; //TODO - PBI - Tenant settings
            $scope.$parent.vm.learningItemResourceObject.$promise.then(function () {
                vm.learningItem = $scope.$parent.vm.learningItem;
            }).catch(angular.noop);
            vm.getLearningItemPracticalEval = function (id) {
                return _.find(vm.learningItem.learningItemFiles, { localizationId: id });
            };
            vm.reachedMaxFilesForLocalization = function (id) {
                return _.where(vm.learningItem.learningItemFiles, { localizationId: id }).length >= vm.MaxAllowedFiles;
            };
            vm.deleteFile = function (file) {
                var modal = $uibModal.open({
                    templateUrl: "deleteFileConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    learningItemFilesResource.deleteFile({ code: vm.learningItem.code, id: file.id }, function () {
                        vm.learningItem.learningItemFiles = _.without(vm.learningItem.learningItemFiles, file);
                        reloadLocalizationRepeater();
                    }, function () {
                        notify({ messageTemplate: "<span translate='common.genericError'></span>", classes: "alert-danger" });
                    });
                }).catch(angular.noop);
            };
            vm.upload = function (file, errFiles, learningItemPracticalEval, localization) {
                vm.file = file;
                vm.localizationId = localization.id;
                vm.localizationCulture = localization.languageCulture;
                if (errFiles.length > 0) {
                    vm.file = errFiles[0];
                    if (vm.file.$error === "maxSize")
                        notify({ "messageTemplate": "<span translate='common.dropzone.fileTooBigMessage'></span>", "classes": "alert-danger" });
                    else if (vm.file.$error === "pattern")
                        notify({ "messageTemplate": "<span translate='common.dropzone.invalidFileTypeMessage'></span>", "classes": "alert-danger" });
                    else
                        notify({ "messageTemplate": "<span translate='common.dropzone.generalErrorMessage'></span>", "classes": "alert-danger" });
                    return;
                }
                //TODO - PBI - Handle duplicate files if we are allowing more than file per language
                if (file) {
                    doTheUpload(file);
                }
            };
            function doTheUpload(file) {
                file.upload = Upload.upload({
                    url: "api/learningItemFiles/" + vm.learningItem.code + "/" + vm.localizationCulture,
                    data: { file: file }
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        vm.learningItem.learningItemFiles.push(response.data);
                        _.extend(_.find(vm.learningItem.learningItemFiles, { localizationId: vm.localizationId }), response.data);
                        reloadLocalizationRepeater();
                        notify({ "messageTemplate": "<span translate='common.dropzone.uploadedFileMessage'></span>", "classes": "alert-success" });
                        vm.file.progress = 0;
                    });
                }, function (response) {
                    if (response.status > 0) {
                        var error = response.data.exceptionMessage ? response.data.exceptionMessage : response.data.message;
                        notify({ "messageTemplate": "<span data-translate>" + error + "</span>", "classes": "alert-danger" });
                    }
                    vm.file.progress = 0;
                }, function (evt) {
                    vm.file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                });
            }
            function reloadLocalizationRepeater() {
                vm.learningItem.enabledLocalizations = angular.copy(vm.learningItem.enabledLocalizations);
            }
        }
    });
})();
